module.exports = __webpack_public_path__ + "static/media/instagram.8032df14.png";